import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { Page } from ".";
import { AccountSetting, AccountSettingPermission } from "./dtos/AccountSetting";

const ACCOUNT_SETTINGS_SERVICE = `${Constants.API_URL}/bedrock/account_settings`;
const ACCOUNT_SETTING_PERMISSIONS_SERVICE = `${Constants.API_URL}/bedrock/account_setting_permissions`;

export interface AccountSettingPermissionUpdate {
  accountSettingId: string;
  coachId: number;
  value: boolean | null;
}

export interface AccountSettingFilters {
  page?: number;
  perPage?: number;
}

export interface AccountSettingPermissionFilters {
  coachId?: number;
  accountSettingId?: string;
  page?: number;
  perPage?: number;
}

export class AccountSettingServices {
  @scCatchServiceException()
  static async getAccountSettings(params: AccountSettingFilters = {}): Promise<Page<AccountSetting>> {
    const url = ACCOUNT_SETTINGS_SERVICE;
    params.page = params.page ?? 1;
    params.perPage = params.perPage ?? 100;
    const { data } = await axios.get<Page<AccountSetting>>(url, { params });
    return data;
  }

  @scCatchServiceException()
  static async getAccountSettingPermissions(
    filters: AccountSettingPermissionFilters = {}
  ): Promise<Page<AccountSettingPermission>> {
    const params = {
      page: 1,
      perPage: 100,
      ...filters,
    };
    const { data } = await axios.get<Page<AccountSettingPermission>>(ACCOUNT_SETTING_PERMISSIONS_SERVICE, { params });
    return data;
  }

  @scCatchServiceException()
  static async updateAccountSettingPermissions(permissions: AccountSettingPermissionUpdate[]): Promise<void> {
    await axios.patch<void>(ACCOUNT_SETTING_PERMISSIONS_SERVICE, { permissions });
  }
}
